import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/lib/motion";
import { BLOG } from "@/data";

export default function Blog() {
  return (
    <section id="blog" data-testid="blog-section" className="max-w-7xl mx-auto px-6 md:px-12 py-8 md:py-12">
      <div className="flex items-end justify-between mb-14 md:mb-20">
        <div>
          <Eyebrow>Journal</Eyebrow>
          <h2 className="mt-5 font-display font-normal text-4xl md:text-5xl lg:text-6xl tracking-tight">
            Notes on AI &amp; small business.
          </h2>
        </div>
      </div>

      <div className="divide-y divide-brand-peach border-y border-brand-peach">
        {BLOG.map((b, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <motion.a
              href="#book"
              whileHover="hover"
              data-testid={`blog-post-${i}`}
              className="group grid md:grid-cols-12 gap-4 items-center py-8 md:py-10"
            >
              <div className="md:col-span-2 font-mono text-xs uppercase tracking-[0.15em] text-brand-teal">
                {b.date}
              </div>
              <div className="md:col-span-2 font-mono text-xs uppercase tracking-[0.15em] text-brand-ink/60">
                {b.cat}
              </div>
              <h3 className="md:col-span-6 font-display text-2xl md:text-3xl group-hover:text-brand-teal transition-colors duration-300">
                {b.title}
              </h3>
              <div className="md:col-span-2 flex items-center justify-between md:justify-end gap-3 text-brand-ink/60">
                <span className="font-mono text-xs">{b.read}</span>
                <motion.span variants={{ hover: { x: 4, y: -4 } }} className="text-brand-teal">
                  <ArrowUpRight size={22} />
                </motion.span>
              </div>
            </motion.a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
